module.exports = __webpack_public_path__ + "media/CN_011.f48c380a.mp3";